export default {"src":"/_next/static/media/ico_plus_circle.252799e2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};